import qs from 'qs'
import Cookies from 'js-cookie'

import { UTILS__VALIDATOR__is_value } from 'utils/validator'
import { credPassword, credType, credUsername } from './constants'
import { MAIN_SERVER } from './instance'

export const LOGIN = async obj => {
    const data = {
        grant_type: obj.grant_type,
        username: obj.email,
        password: obj.password,
    }

    return await MAIN_SERVER({
        method: 'post',
        url: '/oauth/token',
        headers: {
            Authorization: `${credType} ${window.btoa(`${credUsername}:${credPassword}`)}`,
        },
        data: qs.stringify(data),
    })
}

export const REGISTRATION = async obj => {
    try {
        const data = {}
        if (UTILS__VALIDATOR__is_value(obj.firstName)) {
            data.firstName = obj.firstName
        }
        if (UTILS__VALIDATOR__is_value(obj.lastName)) {
            data.lastName = obj.lastName
        }
        if (UTILS__VALIDATOR__is_value(obj.email)) {
            data.login = obj.email
        }
        if (UTILS__VALIDATOR__is_value(obj.company)) {
            data.company = obj.company
        }
        if (UTILS__VALIDATOR__is_value(obj.password)) {
            data.password = obj.password
        }
        if (UTILS__VALIDATOR__is_value(obj.role_id)) {
            data.roleInProjectId = obj.role_id
        }
        if (UTILS__VALIDATOR__is_value(obj.newsSubscription)) {
            data.newsSubscription = obj.newsSubscription
        }
        const ga = Cookies.get('_ga')
        if (typeof ga !== 'undefined') {
            data.cid = ga
        }

        return await MAIN_SERVER({
            method: 'post',
            url: '/users',
            headers: {
                'Content-Type': 'application/json',
            },
            data,
        })
    } catch (err) {
        throw err
    }
}

export const REFRESH = async refresh => {
    const data = {
        grant_type: 'refresh_token',
        refresh_token: refresh,
        client_id: credUsername,
        client_secret: credPassword,
    }

    return await MAIN_SERVER({
        method: 'post',
        url: `/oauth/token`,
        data: qs.stringify(data),
    })
}
